export default "__VITE_ASSET__DW7jesQz__"